var _circle, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 35,
    fill: "none",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeDasharray: "4,2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#1976D2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 50 A 20 20 0 1 1 70 50 A 20 20 0 1 1 30 50",
    fill: "none",
    strokeWidth: 2,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    fill: "#2196F3"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "3s",
    repeatCount: "indefinite",
    path: "M30 50 A 20 20 0 1 1 70 50 A 20 20 0 1 1 30 50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25 50 A 25 25 0 1 1 75 50 A 25 25 0 1 1 25 50",
    fill: "none",
    strokeWidth: 2,
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    fill: "#2196F3"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "4s",
    repeatCount: "indefinite",
    path: "M25 50 A 25 25 0 1 1 75 50 A 25 25 0 1 1 25 50"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 50 A 30 30 0 1 1 80 50 A 30 30 0 1 1 20 50",
    fill: "none",
    strokeWidth: 2,
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2,
    fill: "#2196F3"
  }, /*#__PURE__*/React.createElement("animateMotion", {
    dur: "5s",
    repeatCount: "indefinite",
    path: "M20 50 A 30 30 0 1 1 80 50 A 30 30 0 1 1 20 50"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#ACF",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: -10,
    y1: -10,
    x2: 10,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: -10,
    x2: -10,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -14,
    x2: 0,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: -14,
    y1: 0,
    x2: 14,
    y2: 0
  })), /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#1976D2"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "white",
    opacity: 0.3,
    transform: "translate(-2 -2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 15,
    r: 3,
    fill: "#2194F3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;5;3",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 50,
    r: 3,
    fill: "#2194F3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;5;3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.4s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 85,
    r: 3,
    fill: "#2194F3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;5;3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "0.8s"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 50,
    r: 3,
    fill: "#2194F3"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "3;5;3",
    dur: "2s",
    repeatCount: "indefinite",
    begin: "1.2s"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNode);
export default __webpack_public_path__ + "static/media/node.d22968958fe8cc091a5818a8e8bfae38.svg";
export { ForwardRef as ReactComponent };